import { useContext } from 'react';
import { IdentificationRequestsContext } from '@pages/IdentificationRequests/IdentificationRequests.query';
import { getRequestDetails } from '@services/queries/onboarding/getRequestDetails';
import { useQuery } from 'react-query';

import { RequestDetailsRaw } from './RequestDetails.raw';

export const RequestDetailsQuery = () => {
  const { selectedRequest } = useContext(IdentificationRequestsContext);

  const selectedRequestValue = selectedRequest.value;

  const { data: assets, isError } = useQuery(
    ['requestDetails', 'assets'],
    async () => {
      return getRequestDetails({
        studioId: selectedRequestValue?.studioId,
        fileId: selectedRequestValue?.fileId,
        groupId: selectedRequestValue?.groupId,
      });
    },
  );
  return <RequestDetailsRaw groupsQuery={assets} isError={isError} />;
};
